export function generateUrlSafeRandomString(length = 96): string {
  const array = new Uint8Array(length)
  crypto.getRandomValues(array)
  const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-._~'
  let out = ''
  for (let i = 0; i < array.length; i++) {
    out += chars[array[i] % chars.length]
  }
  return out
}

export function base64UrlFromArrayBuffer(input: ArrayBuffer): string {
  const bytes = new Uint8Array(input)
  let binary = ''
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i])
  }
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '')
}

export async function sha256Base64Url(input: string): Promise<string> {
  const encoder = new TextEncoder()
  const digest = await crypto.subtle.digest('SHA-256', encoder.encode(input))
  return base64UrlFromArrayBuffer(digest)
}


/**
 * CSRF nonce carried in the OAuth `state` parameter of every connector
 * authorisation redirect. CSPRNG-backed (CASA Q46) — never Math.random(),
 * whose output is predictable from a few prior values and so lets an attacker
 * forge a state that the callback would accept.
 */
export function newCsrfToken(): string {
  return generateUrlSafeRandomString(32)
}
